import isAutheticatedGuard from '@/modules/auth/router/auth-guard'
export default {
    name: 'auth',
    component:()=> import(/* webpackChunkName: "daybook-no-entry"*/'@/modules/auth/layout/AuthLayout.vue'),
    children:[
        {
            path: '',
            name:'login',
            component:()=> import(/* webpackChunkName: "daybook-no-entry"*/'@/modules/auth/views/Login.vue'),
        },
        {
            path: '/register',
            name:'register',
            beforeEnter: [ isAutheticatedGuard],
            
            component:()=> import(/* webpackChunkName: "daybook-no-entry"*/'@/modules/auth/views/Register.vue'),
        },

    ]
}